import React, { useMemo, useState } from "react";
import styles from "./card.module.scss";
import IconStar from '@assets/icons/star_filled.svg?react'
import { LordIcon } from "@src/components/lord-icon/lord-icon";
import { IconInfo } from "@src/constants";
import HoverCard from "./HoverCard";

type Props = {
  titleLine1: string;
  titleLine2?: string;
  mainIcon?: React.ReactNode;
  backGroundUrl?: string;
  imageUrl?: string;
  isNew?: boolean;
  isComingSoon?: boolean;
  isFeatured?: boolean;
  openCard?: () => void;
  className?: string;
  hoverTitle?: React.ReactNode;
  hoverHint?: string;
};

function TransitionCard(props: Props) {
  const {
    titleLine1,
    titleLine2,
    mainIcon,
    imageUrl,
    backGroundUrl,
    isNew,
    isComingSoon,
    isFeatured,
    className='',
    openCard,
    hoverTitle='',
    hoverHint=''
  } = props;
  const [hover, setHover] = useState(false);

  const imageViewStyle = useMemo(() => {
    const classes = [styles.onboardBagImageView];
    
    classes.push(className)

    return classes.join(' ');
  }, [className])

  const imageStyle = useMemo(() => {
    const classes = [styles.transitionImageCard];
    if ( isComingSoon) {
      classes.push(styles.comingSoonImage)
    }
    return classes.join(' ');
  }, [isComingSoon])

  return (
    <div
      className={styles.transitionCard}
      style={{ cursor: isComingSoon ? "default" : "pointer" }}
      onClick={openCard}
    >
      <div
        className={styles.transitionBackground}
        style={{ backgroundImage: `url(${backGroundUrl})` }}
      ></div>
      <div className={styles.cardView}>
        <div
          className={styles.cardTitleView}
        >
          <div>
            {mainIcon}
            <h2
              style={{color: isComingSoon ? "#A0A0A0" : "#274649"}}
              dangerouslySetInnerHTML={{ __html: titleLine1 }}
            ></h2>
            <span
              
              style={{
                color: "#274649",
              }}
            >
            {titleLine2}</span>
            {isFeatured && <div className={styles.featuredLabel}><IconStar /> Featured</div>}
          </div>
          <div className={styles.detailTextView}>Open Parachute's <strong>Educator Onboarding</strong> is designed to prepare teachers to confidently deliver the program in their classrooms. You’ll learn how to navigate the platform and effectively implement the lesson materials with your students.</div>
            {/* <strong>Transitions™</strong> is designed to support students’ Well-being during the Middle-Year transitions between grades 5 and 9. */}
          {isNew && (
            <div className={styles.newLabel}>New</div>
          )}
          {isComingSoon && (
            <div className={styles.newLabel}>Coming Soon</div>
          )}
        </div>
        {imageUrl && (
          <div
            className={imageViewStyle}
          >
            <img
              src={imageUrl}
              alt="Play"
              className={imageStyle}
            />
          </div>
        )}
      </div>
      {hoverTitle && (
        <HoverCard
          title={hoverTitle || ""}
          hint={hoverHint || ""}
          releaseDate={""}
          isActive={hover}
          openCard={openCard}
        />
      )}
      <div
        className={styles.iconWrapper}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <LordIcon
          src={IconInfo}
          isHover={true}
          colors={{ primary: "#274649", secondary: "#274649" }}
          size={26}
        />
      </div>
    </div>
  );
}

export default TransitionCard;
